import useAuthStore from '../../stores/authStore';
import { USER_ROLE } from '../../types/auth';
import SuperAdminDashboard from './SuperAdminDashboard';
import SalonOwnerDashboard from './SalonOwnerDashboard';

const Dashboard = () => {
	const { user } = useAuthStore();

	if (!user) return null;

	switch (user.role) {
		case USER_ROLE.SUPER_ADMIN:
			return <SuperAdminDashboard />;
		case USER_ROLE.SALON_OWNER:
			return <SalonOwnerDashboard />;
		case USER_ROLE.STAFF:
			return <SalonOwnerDashboard />; // For now, staff see same dashboard
		default:
			return <SuperAdminDashboard />;
	}
};

export default Dashboard;
